import { useLocalStorage } from "react-use";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import React from "react";
import { Item } from "@/types/fse";

type RecentItem = Item & { dateAccessed: string };

export const useRecentItems = (maxItems: number = 5) => {
  const userData = useAuthenticatedUser();

  const key = `recentItems_${userData.username}`;

  const [recentItems, setRecentItems] = useLocalStorage<RecentItem[]>(key, []);

  const addRecentItem = React.useCallback(
    (item: Item) => {
      const newItem: RecentItem = {
        ...item,
        dateAccessed: new Date().toISOString(),
      };

      setRecentItems(prev => [newItem, ...(prev || []).filter(i => i.id !== item.id)].slice(0, maxItems));
    },
    [setRecentItems, maxItems],
  );

  return { recentItems: recentItems || [], addRecentItem };
};
